import Axios from 'axios';
import * as Storage from '../services/storage';

const axios = Axios.create({
  baseURL:
    process.env.NODE_ENV === 'production'
      ? `${process.env.REACT_APP_REDE_IZEE_API_URL}`
      : `${process.env.REACT_APP_REDE_IZEE_DEV_API_URL}`,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
});

axios.interceptors.request.use(config => {
  const token = Storage.get('id_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers['Content-Type'] = 'application/json';
  return config;
});

const convertIntoQueryString = (endpoint: any, data: any) => {
  if (!data) {
    return endpoint;
  } else if (typeof data === 'string') {
    return `${endpoint}?${data}`;
  }

  const qs = Object.keys(data)
    .map(key => `${key}=${data[key]}`)
    .join('&');

  return `${endpoint}?${qs}`;
};

const manageResponse = (method: any) =>
  method
    .then((rs: any) => rs.data)
    .catch((error: any) =>
      Promise.reject({
        ...error,
        error: error.response?.data?.message ?? 'Erro ao processar'
      })
    );
export const get = (endpoint: any, queryString = null) =>
  manageResponse(axios.get(convertIntoQueryString(endpoint, queryString)));
